import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Translate, withLocalize } from 'react-localize-redux'

import Modal from '../Modal/Modal'

const buttonClassName =
  'block w-full mt-2 py-3 font-500 text-white text-center uppercase tracking-wide text-sm bg-fern-green rounded-full transition duration-500 focus:outline-none focus:opacity-50'

const ProductInquiry = ({ pagePath, sku, title, color, translate }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleOpen = () => {
    setIsOpen(true)
  }

  const productUrl = `https://cabuyahandmade.com/${pagePath || ''}`
  const productMeta = [color, sku ? `SKU ${sku}` : null]
    .filter(Boolean)
    .join(' · ')
  const emailSubject = `${translate('productInquiryEmailSubject')}: ${
    sku ? `SKU ${sku}` : title
  }`
  const emailBody = [
    translate('productInquiryDefaultMessage'),
    '',
    [title, color].filter(Boolean).join(' · '),
    sku ? `SKU ${sku}` : null,
    productUrl,
  ]
    .filter(value => value !== null)
    .join('\n')
  const emailUrl = `mailto:info@cabuyahandmade.com?subject=${encodeURIComponent(
    emailSubject
  )}&body=${encodeURIComponent(emailBody)}`

  return (
    <div className="2sm:max-w-xs">
      <button type="button" onClick={handleOpen} className={buttonClassName}>
        <Translate id="buy" />
      </button>
      <Modal
        isOpen={isOpen}
        showBorders={false}
        bgClassName="bg-gray-100 rounded-xl"
        onRequestClose={() => setIsOpen(false)}
      >
        {isOpen ? (
          <div className="w-screen max-w-xs px-6 xs:px-8">
            <div className="mb-6 text-center">
              <h2 className="text-2xl lg:text-3xl uppercase tracking-tight leading-none">
                <Translate id="contact" />
              </h2>
              <p className="mt-3 text-sm sm:text-base">
                <Translate id="askAvailabilityAndPrice" />
              </p>
              <div className="mt-4 text-xs uppercase tracking-wide">
                {title}
              </div>
              {productMeta && (
                <div className="mt-1 text-2xs sm:text-xs uppercase tracking-widest opacity-60">
                  {productMeta}
                </div>
              )}
            </div>
            <a href={emailUrl} className={buttonClassName}>
              <Translate id="emailUs" />
            </a>
          </div>
        ) : (
          <div />
        )}
      </Modal>
    </div>
  )
}

ProductInquiry.propTypes = {
  color: PropTypes.string,
  pagePath: PropTypes.string,
  sku: PropTypes.string,
  title: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
}

ProductInquiry.defaultProps = {
  color: '',
  pagePath: '',
  sku: '',
}

export default withLocalize(ProductInquiry)
